export const charMapping = [
    {
        "id": "0",
        "name": "Athletik Ausdauer",
        "keys": [
            "ko",
            "ge",
            "st"
        ],
        "defaultValue": 0
    },
    {
        "id": "1",
        "name": "Athletik Gymnastik",
        "keys": [
            "ge",
            "ge",
            "re"
        ],
        "defaultValue": 0
    },
    {
        "id": "2",
        "name": "Athletik Kraft",
        "keys": [
            "st",
            "ge",
            "ko"
        ],
        "defaultValue": 0
    },
    {
        "id": "3",
        "name": "Einflussnahme",
        "keys": [
            "ch",
            "em",
            "in"
        ],
        "defaultValue": 0
    },
    {
        "id": "4",
        "name": "Gezielte Sprueche",
        "keys": [
            "ge",
            "ge",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "5",
        "name": "Handwerk",
        "keys": [
            "ge",
            "gd",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "6",
        "name": "Kampfmanoever",
        "keys": [
            "ge",
            "re",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "8",
        "name": "Koerperentwicklung",
        "keys": [
            "ko",
            "ko",
            "sd"
        ],
        "defaultValue": 10
    },
    {
        "id": "9",
        "name": "Kunst Aktiv",
        "keys": [
            "ch",
            "em",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "10",
        "name": "List Angriff",
        "keys": [
            "ge",
            "sd",
            "in"
        ],
        "defaultValue": 0
    },
    {
        "id": "11",
        "name": "List Mechanik",
        "keys": [
            "in",
            "ge",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "12",
        "name": "List Tarnung",
        "keys": [
            "ge",
            "sd",
            "in"
        ],
        "defaultValue": 0
    },
    {
        "id": "13",
        "name": "Machtmanipulation",
        "keys": [
            "em",
            "in",
            "ch"
        ],
        "defaultValue": 0
    },
    {
        "id": "14",
        "name": "Machtwahrnehmung",
        "keys": [
            "em",
            "in",
            "ch"
        ],
        "defaultValue": 0
    },
    {
        "id": "15",
        "name": "Magiepunkte entw",
        "keys": [
            "in",
            "em",
            "ch"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "idmapping: did not find value <Kategorie Natur>idmapping: did not find value <Kategorie Natur> entw",
        "keys": [],
        "defaultValue": 0
    },
    {
        "id": "16",
        "name": "Natur Tiere",
        "keys": [
            "em",
            "em",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "17",
        "name": "Natur Umwelt",
        "keys": [
            "sd",
            "in",
            "gd"
        ],
        "defaultValue": 0
    },
    {
        "id": "18",
        "name": "Ruestung Leicht 5 10",
        "keys": [
            "ge",
            "ge",
            "st"
        ],
        "defaultValue": 0
    },
    {
        "id": "19",
        "name": "Ruestung Mittel 13 16",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "20",
        "name": "Ruestung Schwer 17 20",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "21",
        "name": "Selbstkontrolle",
        "keys": [
            "sd",
            "sd",
            "ch"
        ],
        "defaultValue": 0
    },
    {
        "id": "22",
        "name": "Staedtisch",
        "keys": [
            "in",
            "ch",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "23",
        "name": "TechGewerbe allg",
        "keys": [
            "lo",
            "gd",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "24",
        "name": "TechGewerbe berufl",
        "keys": [
            "gd",
            "in",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "25",
        "name": "TechGewerbe prof",
        "keys": [
            "lo",
            "gd",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen 1 Hand Klingen",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen 1 Hand Schlag",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen 2 Hand",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen Stangenwaffen",
        "keys": [
            "st",
            "st",
            "ge"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen Fernkampf",
        "keys": [
            "ge",
            "ge",
            "st"
        ],
        "defaultValue": 0
    },
    {
        "id": "-1",
        "name": "Waffen Wurfwaffen",
        "keys": [
            "ge",
            "ge",
            "st"
        ],
        "defaultValue": 0
    },
    {
        "id": "26",
        "name": "Wahrnehmung Sinne",
        "keys": [
            "in",
            "in",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "27",
        "name": "Wahrnehmung Suche",
        "keys": [
            "in",
            "lo",
            "sd"
        ],
        "defaultValue": 0
    },
    {
        "id": "28",
        "name": "Wissen Allgemein",
        "keys": [
            "gd",
            "gd",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "29",
        "name": "Wissen Magisch",
        "keys": [
            "gd",
            "gd",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "30",
        "name": "Wissen Obskur",
        "keys": [
            "gd",
            "gd",
            "lo"
        ],
        "defaultValue": 0
    },
    {
        "id": "31",
        "name": "Wissen Technisch",
        "keys": [
            "gd",
            "gd",
            "lo"
        ],
        "defaultValue": 0
    }
];
